import React from "react";
import { AlertTriangle } from "lucide-react";

// Catches a likely UNIT mistake (a body weight/height meant in metric typed into
// the imperial field). Daily calorie safety is handled by the engine's floor, so
// this only flags implausible body metrics — not normal small athletes.
export default function LowEnergyWarning({ targets, profile }) {
  if (!profile) return null;
  const kg = parseFloat(profile.weight) || 0;
  const cm = parseFloat(profile.height) || 0;
  const suspectWeight = kg > 0 && kg < 40;   // ~88 lb — almost always a kg-in-lb slip
  const suspectHeight = cm > 0 && cm < 120;  // ~3'11" — almost always a cm/ft slip
  if (!suspectWeight && !suspectHeight) return null;

  const imperialW = profile.weightUnit === "lb";
  const lb = imperialW ? Math.round(kg / 0.45359237) : null;

  return (
    <div data-testid="low-energy-warning"
      className="flex gap-3 border border-[#FF9500]/50 bg-[#FF9500]/10 p-4 mb-6 text-sm text-[#FF9500]">
      <AlertTriangle className="h-5 w-5 shrink-0 mt-0.5" />
      <div className="space-y-1">
        <p className="font-semibold">Please double-check your body measurements.</p>
        <p className="text-[#FFB86B]">
          {suspectWeight && (
            <>Your body weight reads <b>{kg} kg{imperialW ? ` (${lb} lb)` : ""}</b>, which is unusually low. If you meant kilograms, switch the unit toggle next to <b>Body weight</b> to <b>kg</b>. </>
          )}
          {suspectHeight && (
            <>Your height reads <b>{cm} cm</b>, which looks too low — check the <b>cm / ft-in</b> toggle next to Height. </>
          )}
        </p>
      </div>
    </div>
  );
}
